import { createFeatureSelector, createSelector } from '@ngrx/store';
import { paymentLinkState } from './paymentlinks.reducer'


export const selectDataState = createFeatureSelector<paymentLinkState>('paymentlinks');


export const getpaymentLinkResponse = createSelector(
    selectDataState,
    (state: paymentLinkState) => state.getpaymentLinkResponse);



export const getallpaymentlinkExportResponse = createSelector(
    selectDataState,
    (state: paymentLinkState) => state.getallpaymentlinkExportResponse);




//